﻿import { action, computed, makeObservable } from "mobx";
import { Properties } from "../forms/ComponentsMap";

export interface IStateStore<T extends Properties> {
    getState: T,
    setState(state: Partial<T>): void
}

export abstract class StateStore<T extends Properties> implements IStateStore<T> {

    constructor() {
        makeObservable(this, {
            getState: computed,
            setState: action.bound
        });
    }

    public abstract get getState(): T;

    public setState(state: Partial<T>) {
        Object.assign(this, state);
    }
}